export default {
    todasContasContabeis: {
        paginacao: {
            page: 1,
            rowsPerPage: 10,
            descending: false,
            sortBy: ['codigo']
        },
        filtros: {
            conteudo: {
                value: null,
                default: null,
                label: 'Pesquisa'
            }
        }
    },
    contaContabil: {}
}
